'use client';

/**
 * Hook to generate search params for a logout URL
 * @param callbackUrl URL to redirect to after logout (default: '/auth-check/signout')
 * @returns URL string for the logout page
 */

export function useLogOutUrl(callbackUrl: string = '/auth-check/signout') {
  const subriteSignoutUrl = new URL('/api/oidc/session/end', process.env.NEXT_PUBLIC_SUBRITE_URL);
  //Tell subrite what client we are signing out from
  subriteSignoutUrl.searchParams.append('client_id', process.env.NEXT_PUBLIC_SUBRITE_CLIENT_ID!);
  //Tell subrite where to send the user agent after signing out
  const postLogoutRedirectUri = new URL(
    callbackUrl,
    process.env.NEXT_PUBLIC_NEXTAUTH_URL as string,
  );

  subriteSignoutUrl.searchParams.append(
    'post_logout_redirect_uri',
    postLogoutRedirectUri.toString(),
  );
  return subriteSignoutUrl.toString();
}
